<div class="search-input-container" [class.fixed-width]="fixedWidth">
  @if (leftIconAction) {
    <button
      class="action-button left-action"
      [disabled]="isSendingMessage"
      [ngClass]="{ 'empty': isSendingMessage, 'black-background': showBlackButtons }"
      (click)="executeLeftIconAction()">
      <img src="assets/img/attach-photo.svg" />
    </button>
  }

  @if (!leftIconAction) {
    <div class="search-icon">
      <tidy-image [src]="icon" />
    </div>
  }

  <textarea
    #inputElement
    class="search-input"
    [ngModel]="value"
    (ngModelChange)="onInputChange($event)"
    [placeholder]="placeholder | translate"
    (keydown)="onKeyDown($event)"
    rows="1"
    [style.height]="'auto'"
    [style.height.px]="inputElement.scrollHeight"
  ></textarea>

  @if (rightIconAction) {
    <button
      class="action-button right-action"
      [disabled]="isSendingMessage || (isInputEmpty && !hasAttachment)"
      [ngClass]="{ 'empty': (isInputEmpty && !hasAttachment) || isSendingMessage, 'black-background': showBlackButtons }"
      (click)="executeRightIconAction()">
      <img src="assets/img/send-message.svg" />
    </button>
  }

  @if (!rightIconAction && !isInputEmpty) {
    <button
      class="clear-button"
      (click)="clearInput()">
      <mat-icon>close</mat-icon>
    </button>
  }
</div>
